<div class="ml-5">
  <p class="titre1 m-4">
    {{ 'CONTENUS_MANAGEMENT.PAGE_CONTENUS_MANAGEMENT' | translate }}
    <mat-icon class="material-symbols-outlined text-[38px] w-[45px] h-[45px] mt-[5px] mr-[30px] float-right">monitoring</mat-icon>
  </p>
  <div class="flex items-center justify-between mb-4">
    <div class="inline-flex rounded-md shadow-sm" role="group">
      <button type="button"
        [ngClass]="{'bg-red-600 text-white': filter === 'complete', 'bg-gray-200 text-gray-700': filter !== 'complete'}"
        (click)="setFilter('complete')"
        class="px-4 py-2 text-sm font-medium rounded-l-lg focus:z-10 focus:ring-2 focus:ring-blue-500 focus:outline-none">
        {{ 'CONTENUS_MANAGEMENT.TOOGLE_COMPLETE' | translate }}
      </button>
      <button type="button"
        [ngClass]="{'bg-red-600 text-white': filter === 'encours', 'bg-gray-200 text-gray-700': filter !== 'encours'}"
        (click)="setFilter('encours')"
        class="px-4 py-2 text-sm font-medium rounded-r-lg focus:z-10 focus:ring-2 focus:ring-blue-500 focus:outline-none">
        {{ 'CONTENUS_MANAGEMENT.TOOGLE_ENCOURS' | translate }}
      </button>
    </div>
    @if (!isLoading && hasData) {
      <button [matMenuTriggerFor]="exportMenu" class="btn-primary-novo h-8 px-3 py-1 rounded-md flex items-center">
        {{ 'CONTENUS_MANAGEMENT.EXPORT' | translate }}
        <mat-icon>expand_more</mat-icon>
      </button>
    }
    <mat-menu #exportMenu="matMenu" panelClass="export-menu-styling">
      <button mat-menu-item (click)="exporterVersExcel()">
        <mat-icon>table_view</mat-icon>
        <span>{{ 'CONTENUS_MANAGEMENT.EXPORT_EXCEL' | translate }}</span>
      </button>
      <button mat-menu-item (click)="exporterVersPdf()">
        <mat-icon>picture_as_pdf</mat-icon>
        <span>{{ 'CONTENUS_MANAGEMENT.EXPORT_PDF' | translate }}</span>
      </button>
    </mat-menu>
  </div>
  <router-outlet ></router-outlet>
</div>
